import axios from 'axios'
import store from '../store'
import * as Sentry from "@sentry/vue";
import * as SentryTypes from "@sentry/types";

export default function axiosInterceptors() {
  axios.interceptors.request.use(async request => {
    store.commit('setState', { property: 'isLoading', value: true });
    store.commit('setState', { property: 'networkResponse', value: { status: store.state.STATUSES.SUCCESS } });
    return request;
  });

  axios.interceptors.response.use(response => {
    store.commit('setState', { property: 'isLoading', value: false });
    return response;
  }, (error) => {
    // replace individual catch() and finally()
    store.commit('setState', {
      property: 'networkResponse',
      value: { status: error.response.status, message: error.response.data.message }
    });
    store.commit('setState', { property: 'isLoading', value: false });

    Sentry.withScope(function(scope) {
      if (error.response.status < store.state.STATUSES.SERVER_ERR) {
        scope.setLevel(SentryTypes.Severity.Info);
      }
      Sentry.captureException(error);
    });
    return Promise.reject(error);
  });
}
